import varAxios from "../../Comman/axios";
import { GetRegionListUrl,addFreeTextDescriptionUrl, updateFreeTextDescriptionUrl, deleteFreeTextDescriptionUrl, getFreeTextDescriptionListUrl} from '../../Comman/apiEndPoints';

export const GET_PREDEFINED_TEXT_REQUEST = "GET_PREDEFINED_TEXT_REQUEST";
export const GET_PREDEFINED_TEXT_SUCCESS = "GET_PREDEFINED_TEXT_SUCCESS";
export const GET_PREDEFINED_TEXT_LIST_SUCCESS = "GET_PREDEFINED_TEXT_LIST_SUCCESS";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export function addPredefinedTextFunc(payload) {
    return (dispatch) => { 
      dispatch(predefinedTextRequest(true)); 
        return varAxios.post(addFreeTextDescriptionUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                predefinedTextSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
               this.getPredefinedTextListFunc({RegionId:payload.RegionId});
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function deletePredefinedTextFunc(payload,RegionId1) {
    return (dispatch) => { 
      dispatch(predefinedTextRequest(true)); 
        return varAxios.post(deleteFreeTextDescriptionUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                predefinedTextSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
              this.getPredefinedTextListFunc({RegionId:RegionId1});
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function updatePredefinedTextFunc(payload) {
    return (dispatch) => { 
      dispatch(predefinedTextRequest(true)); 
        return varAxios.post(updateFreeTextDescriptionUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                predefinedTextSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
              this.getPredefinedTextListFunc({RegionId:payload.RegionId});
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function predefinedTextRequest(isLoading){
    return {
      type : GET_PREDEFINED_TEXT_REQUEST,
      isLoading
    }
  }
  export function predefinedTextSuccess(isLoading,errorCode, statusCode, message){
    return {
      type : GET_PREDEFINED_TEXT_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      message
    }
  }

export function getPredefinedTextListFunc(RegionId) {
    return (dispatch) => {
      dispatch(predefinedTextRequest(true)); 
        return varAxios.post(getFreeTextDescriptionListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                getPredefinedTextListSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.freeFextDescriptionList)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function getPredefinedTextListSuccess(isLoading,errorCode, statusCode, list){
    return {
      type : GET_PREDEFINED_TEXT_LIST_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list
    }
  }
   export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getPredefinedTextListFunc({RegionId:response.data.regionList[0].ID});
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}